var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.25C9 7.84674 8.76295 8.41903 8.34099 8.84099C7.91903 9.26295 7.34674 9.5 6.75 9.5C6.15326 9.5 5.58097 9.26295 5.15901 8.84099C4.73705 8.41903 4.5 7.84674 4.5 7.25C4.5 6.65326 4.73705 6.08097 5.15901 5.65901C5.58097 5.23705 6.15326 5 6.75 5C7.34674 5 7.91903 5.23705 8.34099 5.65901C8.76295 6.08097 9 6.65326 9 7.25ZM7.5 7.25C7.5 7.05109 7.42098 6.86032 7.28033 6.71967C7.13968 6.57902 6.94891 6.5 6.75 6.5C6.55109 6.5 6.36032 6.57902 6.21967 6.71967C6.07902 6.86032 6 7.05109 6 7.25C6 7.44891 6.07902 7.63968 6.21967 7.78033C6.36032 7.92098 6.55109 8 6.75 8C6.94891 8 7.13968 7.92098 7.28033 7.78033C7.42098 7.63968 7.5 7.44891 7.5 7.25Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H9.879C10.2768 2.00008 10.6583 2.15818 10.9395 2.4395L21.4395 12.9395C21.7207 13.2208 21.8787 13.6023 21.8787 14C21.8787 14.3977 21.7207 14.7792 21.4395 15.0605L14.5605 21.9395C14.2792 22.2207 13.8977 22.3787 13.5 22.3787C13.1023 22.3787 12.7208 22.2207 12.4395 21.9395L1.9395 11.4395C1.65818 11.1583 1.50008 10.7768 1.5 10.379V3.5C1.5 3.10218 1.65804 2.72064 1.93934 2.43934C2.22064 2.15804 2.60218 2 3 2ZM3 10.379L13.5 20.879L20.379 14L9.879 3.5H3V10.379Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQty);
export default __webpack_public_path__ + "static/media/qty.12147b40caae4f521af605c97259f5fd.svg";
export { ForwardRef as ReactComponent };